<script>
    import { onMount } from 'svelte';
    import Legend from './components/Legend.svelte';
    import 'mapbox-gl/dist/mapbox-gl.css';
    import { createNinoMap, fetchNinoManifest } from './utils/ninoMap.js';

    let manifestData = $state();
    let tileset = $state(null);
    let dates = $state([]);
    let dateFloor = $derived(Math.min(...dates));
    let dateCeil = $derived(Math.max(...dates));

    // $inspect(dateFloor, dateCeil);
    onMount(async() => {
        try {
            ({ manifestData, tileset, dates } = await fetchNinoManifest());
        } catch(error) {
            console.error('Error fetching data: ', error);
        }
    });

    // $inspect(manifestData);
    // $inspect(tileset);

    // The globe auto-fits a full hemisphere to its container and re-fits on
    // resize, so no manual per-breakpoint zoom is needed.
    $effect(() => {
        if (tileset) {
            createNinoMap(tileset, 'current-nino-map', { showLabels: true });
        }
    })
</script>

<Legend {dateFloor} {dateCeil}/>
<div class="graphic">
    <div class="current-nino">
        <div class="current-nino-map" id="current-nino-map">
            <span class="nino-label">Niño 3.4 Region</span>
        </div>
    </div>
    

</div>

<style lang='scss'>
h3 {
    margin-bottom: 0;
}

    .year-label {
        position: absolute;
        top: 8px;
        left: 8px;
        z-index: 1;
        margin: 0;
        pointer-events: none;
        font-family: $sans-serif;
        font-weight: 700;
        color: #333333;
        text-shadow:
            0 0 2px #ffffff,
            0 0 2px #ffffff,
            0 0 2px #ffffff;
    }

    .current-nino {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 20px;

        @media #{$desktop} {
            align-items: center;
        }

        .current-year {
            margin: 0 0 4px;
            font-family: $sans-serif;
            font-weight: 700;
        }

        .current-nino-map {
            width: 100%;
            
            aspect-ratio: 1/1;
            position: relative;

            @media #{$desktop} {
                max-width: 450px;
            }

            .nino-label {
                position: absolute;
                top: 42%;
                left: 35%;
                transform: translate(-50%, -100%);

                @media #{$desktop} {
                    top: 44%;
                }
                z-index: 1;
                pointer-events: none;
                white-space: nowrap;
                font-family: $sans-serif;
                font-weight: 500;
                font-size: 14px;
                color: #333333;
                text-shadow:
                    0 0 2px #ffffff,
                    0 0 2px #ffffff,
                    0 0 2px #ffffff;
            }
        }
    }

   
    :global {
        .mapboxgl-control-container {
            display: none;
        }
    }
</style>
